module.exports = __webpack_public_path__ + "img/eight8Red.69dd3529.jpg";